import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/2026/register-mobile-bottom-shard.png")